var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpToDate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "14 8 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1461_33943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12 14.25 14.3232 11.5563 17.359 11.075C17.359 10.7156 17.359 10.3594 17.359 10C17.1976 10 17.0332 10 16.8718 10C16.3329 10 15.8974 9.55313 15.8974 9C15.8974 8.44687 16.3329 8 16.8718 8C17.359 8 17.8462 8 18.3333 8C18.8205 8 19.3077 8 19.7949 8C20.3338 8 20.7692 8.44687 20.7692 9C20.7692 9.55313 20.3338 10 19.7949 10C19.6335 10 19.4691 10 19.3077 10C19.3077 10.3594 19.3077 10.7156 19.3077 11.075C20.4495 11.2563 21.4878 11.75 22.3434 12.4688C22.5627 12.2438 22.7819 12.0188 23.0011 11.7938C23.3817 11.4031 23.9998 11.4031 24.3804 11.7938C24.7611 12.1844 24.7611 12.8187 24.3804 13.2094C24.1369 13.4594 23.8902 13.7125 23.6466 13.9625C23.7014 14.05 23.7562 14.1406 23.808 14.2312C23.5583 14.0844 23.2691 14 22.9615 14C22.0237 14 21.2655 14.775 21.2564 15.7344C21.2564 16.9969 21.2564 18.2625 21.2564 19.525C21.2625 20.6812 21.6157 21.7531 22.2155 22.6375C21.1438 23.4906 19.7949 24 18.3333 24C14.8348 24 12 21.0906 12 17.5ZM17.6026 14C17.6026 15.3344 17.6026 16.6656 17.6026 18C17.6026 18.4156 17.9284 18.75 18.3333 18.75C18.7383 18.75 19.0641 18.4156 19.0641 18C19.0641 16.6656 19.0641 15.3344 19.0641 14C19.0641 13.5844 18.7383 13.25 18.3333 13.25C17.9284 13.25 17.6026 13.5844 17.6026 14ZM22.2308 15.75C22.2308 15.3344 22.5566 15 22.9615 15C23.3665 15 23.6923 15.3344 23.6923 15.75C23.6923 15.8812 23.6923 16.0156 23.6923 16.1469C24.4688 15.4344 25.4918 15 26.6154 15C28.4149 15 29.9587 16.1125 30.6346 17.7C30.796 18.0781 30.6255 18.5219 30.2571 18.6875C29.8886 18.8531 29.4563 18.6781 29.2949 18.3C28.8442 17.2406 27.812 16.5 26.6154 16.5C25.7476 16.5 24.9712 16.8844 24.4353 17.5C24.755 17.5 25.0777 17.5 25.3974 17.5C25.8024 17.5 26.1282 17.8344 26.1282 18.25C26.1282 18.6656 25.8024 19 25.3974 19C24.5845 19 23.7745 19 22.9615 19C22.5566 19 22.2308 18.6656 22.2308 18.25V15.75ZM22.5962 21.3C22.4348 20.9219 22.6053 20.4781 22.9737 20.3125C23.3421 20.1469 23.7745 20.3219 23.9359 20.7C24.3865 21.7594 25.4188 22.5 26.6154 22.5C27.4832 22.5 28.2596 22.1156 28.7955 21.5C28.4758 21.5 28.153 21.5 27.8333 21.5C27.4284 21.5 27.1026 21.1656 27.1026 20.75C27.1026 20.3344 27.4284 20 27.8333 20C28.6463 20 29.4562 20 30.2692 20C30.6742 20 31 20.3344 31 20.75C31 21.5844 31 22.4156 31 23.25C31 23.6656 30.6742 24 30.2692 24C29.8643 24 29.5385 23.6656 29.5385 23.25C29.5385 23.1187 29.5385 22.9844 29.5385 22.8531C28.762 23.5656 27.7389 24 26.6154 24C24.8159 24 23.2721 22.8875 22.5962 21.3Z",
    fill: "url(#paint0_linear_1461_33943)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1461_33943",
    x: 0,
    y: 0,
    width: 43,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1461_33943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1461_33943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_33943",
    x1: 26.4564,
    y1: 28.1905,
    x2: 19.7879,
    y2: 4.14822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91D8BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpToDate);
export default __webpack_public_path__ + "static/media/upToDate.360a399767f8332e8b5ac0c1647da7cc.svg";
export { ForwardRef as ReactComponent };